<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { createTextToast } from '@/utils/ToastUtils.ts';
import { ROUTES } from '@/router.ts';
import { logInTransferTokenAction } from '@/actions/auth/LogInTransferTokenAction.ts';
import Loader from '@/components/loader/Loader.vue';
import { logger } from '@/lib/logger.ts';

const route = useRoute();
const router = useRouter();

onMounted(async () => {
    const token = route.query['t'];

    if (!token) {
        createTextToast('Missing transfer token', 'Please log in manually', 'destructive', false);

        await router.push(ROUTES.index);

        return;
    }

    try {
        await logInTransferTokenAction(token.toString());
    } catch (error) {
        logger.error('Login transfer error:', error);

        createTextToast(
            'Failed to automatically log you in',
            'Please log in manually',
            'destructive',
            false,
        );

        await router.push(ROUTES.authLogin);

        return;
    }
});
</script>

<template>
    <div class="flex-shrink flex-grow p-20 text-center">
        <div class="flex flex-col items-center justify-center">
            <h2 class="mb-8 text-xl">Logging you in... 🧙</h2>
            <Loader :width="32" :height="32" />
        </div>
    </div>
</template>
